import { render, staticRenderFns } from "./QRPayment.vue?vue&type=template&id=7c71a9c9&scoped=true"
import script from "./QRPayment.vue?vue&type=script&lang=js"
export * from "./QRPayment.vue?vue&type=script&lang=js"
import style0 from "./QRPayment.vue?vue&type=style&index=0&id=7c71a9c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c71a9c9",
  null
  
)

export default component.exports